import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import Drawer from '../../../components/AppDrawer';
import OfferingCategoryForm, { type OfferingCategoryFormFieldValues } from './OfferingCategoryForm';
import type { OfferingCategoryDetail, OfferingCategoryFormValues } from '../types';

export interface OfferingCategoryFormDrawerProps {
  open: boolean;
  onClose: () => void;
  mode: 'add' | 'edit';
  offeringCategoryId: string | null;
  offeringCategory: OfferingCategoryDetail | null | undefined;
  loadingOfferingCategory: boolean;
  onSave: (values: OfferingCategoryFormValues) => void;
  saving: boolean;
}

const OfferingCategoryFormDrawer: React.FC<OfferingCategoryFormDrawerProps> = ({
  open,
  onClose,
  mode,
  offeringCategory,
  loadingOfferingCategory,
  onSave,
  saving,
}) => {
  const [form] = Form.useForm<OfferingCategoryFormFieldValues>();

  useEffect(() => {
    if (!open) return;
    if (mode === 'add') {
      form.resetFields();
      form.setFieldsValue({ isActive: true });
    }
  }, [open, mode, form]);

  const title = mode === 'add' ? 'Add category' : 'Edit category';

  return (
    <Drawer
      title={title}
      destroyOnClose
      size="large"
      placement="right"
      open={open}
      onClose={onClose}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      }
    >
      {(mode === 'add' || !loadingOfferingCategory) && (
        <OfferingCategoryForm
          form={form}
          initialValues={mode === 'edit' ? offeringCategory ?? null : null}
          onFinish={onSave}
        />
      )}
    </Drawer>
  );
};

export default OfferingCategoryFormDrawer;
